<template>
  <span>
    <div
      v-if="data.length"
      class="pt-1"
    >
      <p class="text-center text-primary">
        Applications by Certificate Scheme
      </p>
      <p
        v-if="data.length > topN"
        class="text-center text-muted small mb-0"
      >
        Showing top {{ topN }} of {{ data.length }} schemes
      </p>
      <apexchart
        type="bar"
        :height="chartHeight"
        :options="chartOptions"
        :series="seriesData"
      />
    </div>
    <div v-else>
      <p class="py-2 text-center text-primary">
        No data yet!
      </p>
    </div>
  </span>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

const TOP_N = 15

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { topN: TOP_N }
  },
  computed: {
    // Data already arrives sorted desc by total (backend) - only the top N
    // are worth a bar's-worth of vertical space; a 37-category bar chart is
    // illegible regardless of height. The rest stay reachable via the
    // Certificate Scheme filter dropdown and the detail table.
    visibleData() {
      return this.data.slice(0, this.topN)
    },
    chartHeight() {
      return Math.max(300, this.visibleData.length * 32)
    },
    categoriesData() {
      return this.visibleData.map(item => item.name)
    },
    seriesData() {
      return [{ data: this.visibleData.map(item => item.total), name: 'Applications' }]
    },
    chartOptions() {
      return {
        chart: {
          type: 'bar',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            borderRadius: 2,
          },
        },
        colors: ['#33b2df'],
        dataLabels: {
          enabled: true,
        },
        xaxis: {
          categories: this.categoriesData,
        },
        tooltip: {
          theme: 'dark',
        },
      }
    },
  },
}
</script>
